/* eslint-disable */
/**
 * return tree view ,
 * set 4 spaces before initital string if it has depth
 * @param {string} string - text in select label
 * @param {number} by - depth
 */
import Confirm from '@app/UiElements/Confirm'

const NOT_DEPTH = 1
const IDENTS_SIZE = 4
const INIT_VAL = 0

export function outstand(string, by) {
  if (by < NOT_DEPTH) {
    return string
  }

  const whitespace = '\u00A0'.repeat(IDENTS_SIZE)
  const marker = ''
  // const marker = '\uFE42'
  // const marker = '\u232A'

  return whitespace.repeat(by) + (by > INIT_VAL ? marker : '') + string
}

export function confirmWithPromise(question, $this) {
  return new Promise((res, rej) => {
    const pr = arg => new Promise((resolve, reject) => {
      if (true === arg) {
        resolve(arg)
      } else {
        reject(new Error('...'))
      }
    }).then(result => {
      res(result)
    }, () => {
      rej()
    })
    $this.$modal.show(
      Confirm,
      {
        question,
        promise: pr,
      }, {
        height: 'auto',
        adaptive: true,
        classes: ['defaultModal']
      }
    )
  })
}

/**
 * @param {string} path - name of key(
 *  f.e. Object is -{key: {child_key: 'test'}}, path - key, child_key
 * )
 */
export function pathGetter(path) {
  if (!Array.isArray(path)) {
    path = Array.from(arguments)
  }

  return item => path.reduce((acc, x) => (acc ? acc[x] : '-'), item)
}

export class Field {
  constructor(key, label = null, getter = null, parameters = {}) {
    if (null !== label && is.function(label)) {
      label = null
      getter = label
      parameters = getter
    }

    if (null !== getter && is.not.function(getter)) {
      getter = null
      parameters = getter
    }

    this.key = key
    this.label = label || this.key.toTitle()
    this.getter = getter || pathGetter(this.key)
  }

  getValue(obj) {
    return this.getter(obj)
  }
}
/**
 * simple debounce 
 * @param {function} f - fn for callback
 * @param {number} ms - time for delay
 */
export function debounce(f, ms) {
  let isCooldown = false

  // eslint-disable-next-line func-names
  return function () {
    if (isCooldown) return

    f.apply(this, arguments)

    isCooldown = true

    setTimeout(() => {
      isCooldown = false
      return false
    }, ms)
  }
}

export function getId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|shorts\/|live\/|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  const eleven = 11;
  if (match && match[2].length === eleven) {
    return match[2];
  }
  return new Error('error parsed link');
}


const zero = 0

function CheckSize(selector) {
  if (selector.offsetParent &&
    selector.offsetWidth > selector.offsetParent.offsetWidth) {
    return true
  }
  return false
}

document.addEventListener('data:load', () => {
  let table = Array.from(document.getElementsByClassName('ds-table'))
  if (zero < table.length) {

    table.forEach(element => {
      if (CheckSize(element)) {
        let parent = element.parentNode
        let wrapper = document.createElement('div')
        wrapper.classList.add('scroller')
        parent.replaceChild(wrapper, element)
        wrapper.appendChild(element)
      }
    })
  }
})


export const toPromise = (result) => {
  if (!result) return Promise.reject()
  return Promise.resolve(result)
}

export const groupBy = (arr, fn) => 
  arr.map('function' === typeof fn ? fn : val => val[fn]).reduce((acc, val, i) => {
    acc[val] = (acc[val] || []).concat(arr[i])
    return acc
  }, {})
